import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import TimberClassName from "../../components/timberClass/TimberClassDetail/TimberClassName.tsx";
import {useLocationFormState} from "../../components/timberClass/TimberClassForm/TimberClassUpdateForm";
import TimberClassUpdateFormProvider from "../../components/timberClass/TimberClassForm/TimberClassUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TimberClassUpdateEditPage = () => {
    
    useTitle(t`Update Timber Class`);

    const { timberClassId: id } = useParams();
    
    return (
        <Box data-testid="TimberClass-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="TimberClass-update-title"
                    >
                        <Trans>Edit Timber Class</Trans>:  <TimberClassName id={id}/>
                    </Typography>
                    <TimberClassUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default TimberClassUpdateEditPage;
